import { styled } from '@arpeggi/ui'

export const ExternalLink = styled('a', {
  color: '$indigo0800'
})
